import React from 'react';
import PropTypes from 'prop-types';
import { AsyncPaginate } from 'react-select-async-paginate';

import client from '../../services/graphql';
import { WORKSPACE_LIST } from './graphql';

const CompaniesDropdown = (props) => {
  const {
    setCompanyId,
  } = props;

  const LIMIT = 10;

  const onChange = (newValue) => {
    setCompanyId(newValue.id);
  };

  const loadOptions = async (search, loadedOptions) => {
    const offset = loadedOptions.length || 0;
    const { data } = await client.getClient().query({
      query: WORKSPACE_LIST,
      variables: {
        limit: LIMIT,
        offset,
        search,
      },
    });
    const companies = data.workspaceList.companies || [];
    const hasMore = companies.length === LIMIT;

    return {
      options: data.workspaceList.companies,
      hasMore,
    };
  };

  return (
    <AsyncPaginate
      loadOptions={loadOptions}
      onChange={onChange}
      isSearchable
      placeholder="Select a company"
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
    />
  );
};

CompaniesDropdown.propTypes = {
  setCompanyId: PropTypes.func.isRequired,
};

export default CompaniesDropdown;
